import {Component, Input} from '@angular/core';
import {Company} from "../../../../interfaces/company.interface";
import {NgForOf, NgIf} from "@angular/common";
import {AssistantPromptComponent} from "../../../../common/assistant-prompt/assistant-prompt.component";

@Component({
  selector: 'app-company-information',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    AssistantPromptComponent
  ],
  templateUrl: './company-information.component.html',
  styleUrl: './company-information.component.scss'
})
export class CompanyInformationComponent {
  @Input() report: any;
  @Input() company: Company;
}
